export default function _locationBar() {
    /**
     * Location bar button selector
     * @const {string}
     */
    const LOCATIONBARBUTTON_SELECTOR = '.location-bar__cta button';

    /**
     * Create a new Location bar
     * @param {HTMLElement} button - The HTML element of the location bar
     * @class
     */
    class LocationBar {
        constructor(locationBarButtonElement) {
            // Find the button up the DOM tree
            this.button = locationBarButtonElement;

            // Add the event listener to the button
            this.button.addEventListener('click', () => {
                this.changeUrl();
            });
        }

        /**
         * Event handler for button click
         */
        changeUrl() {
            // get current URL
            const currentUrl = window.location.href;
            let updatedUrl = '';

            if (currentUrl.includes('seq')) {
                updatedUrl = currentUrl.replace('seq', 'qld');
            } else if (currentUrl.includes('qld')) {
                updatedUrl = currentUrl.replace('qld', 'seq');
            }

            // navigate to the new url on button click
            if (updatedUrl) {
                window.location.href = updatedUrl;
            }
        }
    }

    // Find all accordions and created handler objects
    const locationBarButtonElement = document.querySelector(
        LOCATIONBARBUTTON_SELECTOR
    );

    if (!locationBarButtonElement || locationBarButtonElement.button) {
        return;
    }

    locationBarButtonElement.button = new LocationBar(locationBarButtonElement);
}

_locationBar();
